module Elma.Bindings {

    // overwrite tapas binding
    export class FormSubmitOnChange {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

			var load = bindingContext.$root.load();
			var timeout;
			
			var text = valueAccessor().text;
			var delay = valueAccessor().delay;
           
            var $elm = $(element);
            
            var selectedFilters = $(".filterBox.accordion .rows[data-selected=True]");
            selectedFilters.parents(".filterBox.accordion").addClass("active");

            $elm.on("change", function () {
                var $sortRadio = $elm.find(".js-sort-radio:checked");

                if ($sortRadio) {
                    // if we have multiple sorting
                    // we choose only one name for the sorting to not confuse DW 
                    // e.g either sort by price or sort by name
                    // .js-sort-input is a hidden input field, that changes names 

                    let defer = $.Deferred();

                    let sortName = defer.then(function (value: string) {
                       return $elm.find(".js-sort-input").val(value); // update correct value of sort by according to radio picked
                    });

                    defer.resolve($sortRadio.attr("data-sort-name"));

                    // wait until value is set before activating submit
                    defer.done((value) => {
                        load.active(true);
                        load.text(text);
                        $elm.submit();
                    });
                }
                else {
                    if (!delay) {
                        load.active(true);
                        load.text(text);
                        $elm.submit();
                    }
                    else {
                        clearTimeout(timeout);

                        timeout = setTimeout(function () {
                            load.active(true);
                            load.text(text);

                            $elm.submit();
                        }, delay);
                    }
                }
				
			});

			$(window).unload(function () {
				load.active(false);
			});
        }
    }
    ko.bindingHandlers['formSubmitOnChange'] = new FormSubmitOnChange();
}